<script setup lang="ts">
import type { ApiResponseErrors } from 'ui/util/api/ApiResponse';

defineProps<{
  error: NonNullable<ApiResponseErrors>,
}>();
</script>

<template>
  <UAlert
    title=""
    color="error"
    variant="subtle"
    role="alert"
    data-cy="cy-error-api"
  >
    <template #leading>
      <UiFaIcon
        :icon="['fal', 'circle-exclamation']"
        class="pt-0.5"
        aria-hidden="true"
      />
    </template>
    <template #title>
      <template v-if="'cancel' in error">
        Request cancelled
      </template>
      <template v-else>
        {{ error.error.error_message }}
      </template>
    </template>
  </UAlert>
</template>
